import { render, staticRenderFns } from "./ContactPeopleForm.vue?vue&type=template&id=176fdaaa&scoped=true"
import script from "./ContactPeopleForm.vue?vue&type=script&lang=ts"
export * from "./ContactPeopleForm.vue?vue&type=script&lang=ts"
import style0 from "./ContactPeopleForm.vue?vue&type=style&index=0&id=176fdaaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fdaaa",
  null
  
)

export default component.exports